import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import formatDate from 'src/app/helpers/format-date';
import { FinishedOutOrder } from 'src/models/OutOrder';

@Component({
  selector: 'app-sell-orders-table',
  templateUrl: './sell-orders-table.component.html',
  styleUrls: ['./sell-orders-table.component.scss']
})
export class SellOrdersTableComponent implements OnInit {
  @Input() sellOrders: FinishedOutOrder[] = [];
  @Output() clicked = new EventEmitter();
  @Output() onFilterValuesChange = new EventEmitter();
  appliedFilters = {};
  sortParams = {
    orderBy: 'date',
    sortBy: 'DESC'
  };

  constructor() { }

  ngOnInit(): void {
  }

  itemClicked(sellOrder: FinishedOutOrder, column?: string) {
    this.clicked.emit({ sellOrder, column });
  }

  formatDate(date) {
    return formatDate(date);
  }

  onFiltersApply(params: { sortParams, filterParams }) {
    this.appliedFilters = params?.filterParams;
    this.sortParams = this.setSortParams(params?.sortParams);
    this.onFilterValuesChange.emit(params);
  }

  setSortParams(sort) {
    if (!sort || !sort.sortBy) {
      return;
    }
    return sort;
  }

}
